// Function to get a cookie by name
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

// Function to set a cookie
const setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

function setMarketCookie() {
  var hostname = window.location.hostname;

  if (hostname === "botas.cz") {
    // CZ market settings
    setCookie("n_market", "CZ", 7);
    setCookie("n_marketVatRate", 21, 7);
    setCookie("n_currency", "CZK", 7);
    setCookie("n_language", "cs", 7);
    setCookie("n_currencySymbol-place", "after", 7);
    setCookie("n_domain", "botas.cz", 7);
  } else if (hostname === "botas.sk") {
    // SK market settings
    setCookie("n_market", "SK", 7);
    setCookie("n_marketVatRate", 20, 7);
    setCookie("n_currency", "EUR", 7);
    setCookie("n_language", "sk", 7);
    setCookie("n_currencySymbol-place", "before", 7);
    setCookie("n_domain", "botas.sk", 7);
  } else if (hostname === "botasauthentic.com") {
    // SK market settings
    setCookie("n_market", "COM", 7);
    setCookie("n_marketVatRate", 20, 7);
    setCookie("n_currency", "EUR", 7);
    setCookie("n_language", "en", 7);
    setCookie("n_currencySymbol-place", "before", 7);
    setCookie("n_domain", "botasauthentic.com", 7);
  }
}

window.addEventListener("load", setMarketCookie);

// Function to handle checkout session with cart items verification
const handleCheckoutSession = async () => {
  let sessionValue = getCookie("n_checkoutSession");

  try {
    // Step 1: Fetch current cart data from /cart.js
    const cartResponse = await fetch("/cart.js");
    if (!cartResponse.ok) {
      throw new Error(`Error fetching cart data: ${cartResponse.statusText}`);
    }
    const cartData = await cartResponse.json();

    // Format current cart items to match the required "variant_id(quantity)" format
    const currentCartItems = cartData.items
      .map(item => `${item.variant_id}(${item.quantity})`)
      .join(",");

    // Format current cart items to match the required "variant_id" format
    const currentCartItemsArray = cartData.items.map(item => item.variant_id);

    // Step 2: If session cookie exists, verify cart items and checkout status
    if (sessionValue) {
      const checkoutResponse = await fetch(`/a/api/retrievecheckout/${sessionValue}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!checkoutResponse.ok) {
        throw new Error(`Error retrieving checkout data: ${checkoutResponse.statusText}`);
      }

      const checkoutData = await checkoutResponse.json();
      const existingCartItems = checkoutData.response.cartItems;
      const checkoutStatus = checkoutData.response.checkoutStatus;

      if (checkoutStatus === false) {
        console.log("Checkout session is inactive, recreating a new session...");
        setCookie("n_checkoutSession", "", -1);
        sessionValue = null;
      } else {
        if (existingCartItems === currentCartItems) {
          window.location.href = `/pages/pokladna?nchk=${sessionValue}`;
          return;
        } else {
          const updateResponse = await fetch(`/a/api/updatecheckout/${sessionValue}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ cartItems: currentCartItems }),
          });

          if (!updateResponse.ok) {
            throw new Error(`Error updating checkout data: ${updateResponse.statusText}`);
          }

          window.location.href = `/pages/pokladna?nchk=${sessionValue}`;
          return;
        }
      }
    }
    
    const response = await fetch("/a/api/createcheckout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        type: "newcheckout",
        checkout: {
          market_id: getCookie("n_market"),
          market_domain: getCookie("n_domain"),
          currency: getCookie("n_currency"),
          cartItems: currentCartItems,
          status: "open"
        },
      }),
    });

    if (!response.ok) {
      throw new Error(`Error creating new checkout session: ${response.statusText}`);
    }

    const data = await response.json();
    sessionValue = data.checkout_session;

    

    setCookie("n_checkoutSession", sessionValue, 31);
    console.log("n_checkoutSession cookie created:", sessionValue);

    // Send the Begin Checkout Event
    sendBeginCheckoutEvent({
      items: cartData.items.map(item => ({
        item_id: item.id,
        item_name: item.title,
        price: item.price / 100,
        quantity: item.quantity,
        item_category: item.product_type || "", // Optional category
      })),
      value: cartData.total_price / 100, // Convert to standard currency value
      currency: cartData.currency || "USD", // Default currency if not provided
      transaction_id: sessionValue,
    });

    window.location.href = `/pages/pokladna?nchk=${sessionValue}`;

  } catch (error) {
    console.error("Failed to handle checkout session:", error);
  }
};

// Function to set default variant to size 42 if available
const setDefaultVariant42 = () => {
  // Check if we're on a product page and there's no variant in URL
  const urlParams = new URLSearchParams(window.location.search);
  const hasVariantInUrl = urlParams.has('variant');
  
  if (hasVariantInUrl) {
    return; // Don't override if variant is already specified in URL
  }
  
  // Wait for variant picker to be defined and available
  customElements.whenDefined('variant-picker').then(() => {
    const variantPicker = document.querySelector('variant-picker');
    
    if (!variantPicker) {
      return; // No variant picker on this page
    }
    
    // Get all variants from the data script
    const variantsScript = variantPicker.querySelector('[data-variant-picker-variants]');
    if (!variantsScript) {
      return;
    }
    
    const variants = JSON.parse(variantsScript.textContent);
    
    // Find first available variant with option value "42"
    const variant42 = variants.find(variant => {
      return variant.available && variant.options.some(option => option === '42');
    });
    
    if (!variant42) {
      return;
    }
    
    // Find which option position has the "42" value
    const option42Index = variant42.options.findIndex(option => option === '42');
    
    // Find all option input containers
    const optionInputs = variantPicker.querySelectorAll('[data-variant-picker-option-inputs]');
    
    if (optionInputs[option42Index]) {
      // Find the radio input for "42" in that option
      const radioInputs = optionInputs[option42Index].querySelectorAll('input[type="radio"]');
      const radio42 = Array.from(radioInputs).find(input => input.value === '42');
      
      if (!radio42) {
        return;
      }
      
      if (radio42 && !radio42.checked) {
        // Trigger click on the size 42 option
        radio42.click();
        
        // Call checkInventory to update stock status for size 42
        if (typeof window.checkInventory === 'function' && variant42.sku) {
          window.checkInventory(variant42.sku);
        }
      }
    }
  });
};

// Run on page load
window.addEventListener('DOMContentLoaded', setDefaultVariant42);
